import { SAVE_FOOTER } from './actionTypes'
import { FooterType } from './types'
import { PageModel } from '../../../types/footer/footer_model'

export const saveFooter = (footer: PageModel[]): FooterType => {
	return ({
		type: SAVE_FOOTER,
		payload: footer
	})
}
